

export const environment = {
  enableFeature:false,


  production: false,

  enableLocations: true,
  

  environment:'dev',
  
  
  baseURL: 'https://api.dev.business.stories.me',

  
  apiEndPoint: "https://amgmaa-dev.mercedes-benz.com/aca",
  phraseEndPoint: 'https://api.phrase.com/v2/projects',
  

  proxyUrl: "https://proxy.dev.stories.me",
  // proxyUrl: 'http://localhost:4202',
  
  routeBaseURL: "https://dev.stories.me",
  bpBaseURL:"https://dev.business.stories.me",

  
  supported_language:['en', 'de', 'en-GB', 'de-DE', 'es-ES', 'fr-FR', 'ko-KR', 'cs-CZ'],

};
